import { styled } from "@mui/system";

export const DcaContainer = styled("div")(({ theme }) => ({
  width: "100%",
  padding: "12px 24px 24px 24px",
  borderRadius: "20px",
  background: theme.palette.background.default,
  boxShadow: "0px 4px 20px 0px rgba(173, 192, 203, 0.30)",
}));
